import request from '@/utils/request'

// 分页查询小区信息
export function getPageList(params) {
  return request({
    url: '/hrApi/community',
    method: 'get',
    params: params
  })
}

// 获取小区列表
export function getList(params) {
  return request({
    url: '/hrApi/community/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑小区
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/community',
    method: 'post',
    data: data
  })
}

// 删除小区
export function deleteData(id) {
  return request({
    url: '/hrApi/community/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/community.js